// @flow
import React from 'react';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  title: string,
  author?: string,
};

export const Quote = (props: Props) => {
  const { title, author } = props;

  return (
    <div className={'quote'}>
      <h2>{title}</h2>
      {author && (
        <h4>
          <span className={'h4-font'}>&mdash;&nbsp;</span>
          {author}
        </h4>
      )}
    </div>
  );
};
